import type { LucideIcon } from 'lucide-react'
import { UsersRound, Settings } from 'lucide-react'

import { paths } from 'src/config/paths'
import { UsersFilled } from 'src/shared/components/icons/feed/users-filled'
import { UsersOutline } from 'src/shared/components/icons/feed/users-outline'
import { BriefcaseFilled } from 'src/shared/components/icons/referrals/briefcase-filled'
import { BriefcaseOutline } from 'src/shared/components/icons/referrals/briefcase-outline'
import { ROLES } from 'src/shared/features/users/types/roles'

export type NavItem = {
  defaultIcon: LucideIcon
  activeIcon: LucideIcon
  title: string
  url: string
  pro?: boolean
  comingSoon?: boolean
  primary?: boolean
  requiredRole?: ROLES
}

export const SidebarMenuItemsTop: NavItem[] = [
  { defaultIcon: UsersOutline, activeIcon: UsersFilled, title: 'Feed', url: paths.feed.path },
  { defaultIcon: BriefcaseOutline, activeIcon: BriefcaseFilled, title: 'Business', url: paths.referrals.list.path },
]

export const SidebarMenuItemsBottom: NavItem[] = [
  { defaultIcon: UsersRound, activeIcon: UsersRound, title: 'Admin', url: '/admin', requiredRole: ROLES.ADMIN },
  { defaultIcon: Settings, activeIcon: Settings, title: 'Settings', url: '/settings' },
]

export const mobileMenuItemsTop: NavItem[] = [
  { defaultIcon: UsersOutline, activeIcon: UsersFilled, title: 'Feed', url: paths.feed.path },
  { defaultIcon: BriefcaseOutline, activeIcon: BriefcaseFilled, title: 'Business', url: paths.referrals.list.path },
]

export const mobileMenuItemsBottom: NavItem[] = [
  { defaultIcon: UsersRound, activeIcon: UsersRound, title: 'Admin', url: '/admin', requiredRole: ROLES.ADMIN },
  { defaultIcon: Settings, activeIcon: Settings, title: 'Settings', url: '/settings' },
]
